import React, { Component } from "react";
import {
  Table,
  FormGroup,
  Button,
  Modal,
  Row,
  Col,
  ControlLabel,
  FormControl
} from "react-bootstrap";
// import Moment from "react-moment";
// import { Link } from "react-router-dom";
import { Confirm } from "react-confirm-bootstrap";

class AnswerTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editModal: false,
      editObj: {
        text: "",
        order: "",
        weight: ""
      },
    };

    this.handleEditChange = this.handleEditChange.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }
  componentDidMount(){
    // console.log("Answer Table mounted",this.props.answers);
    console.log("Answer Table mounted");
  }

  
  handleEditChange(e, attribute) {
    const target = e.target;
    let temp = Object.assign({}, this.state.editObj);
    temp[attribute] = target.value;
    this.setState({ editObj: temp });
  }

  handleUpdate(e) {
    this.setState({ editModal: false });
    const answer = Object.assign({}, this.state.editObj);
    this.props.onUpdate(answer);
    // this.setState({editObj: null});
  }

  handleConfirm(obj) {
    this.props.onDelete(obj);
  }

  render() {
    

    //first if statement shows no Answers added if ther are no answers
    //Secon one maps objects with their indexes to the table
    const content =
      !this.props.answers || this.props.answers.length === 0 ? (
        <tr>
          <td>No {this.props.objecttype} added</td>
          {this.props.attributes.map((attribute, index) => (
            <td key={index}>No {this.props.objecttype} added</td>
          ))}
        </tr>
      ) : (
        this.props.answers.map((obj, index) => (
          <tr key={index}>
            <td>{index + 1}</td>
            {this.props.attributes.map((attribute, index2) => {
              // const currThis = this;
              if (attribute === "weight")
              // console.log("curr obj", obj);
              // console.log("curr attriburet",attribute);
              // console.log("curr index",index);
                return (
                  <td key={index + 2} className="tg-list-item">

                    {obj.weight}
                    {/* <input
                      checked={obj[attribute]}
                      disabled={obj[attribute]}
                      onChange={() => currThis.props.onCheck(obj._id, index)}
                      className="tgl tgl-skewed"
                      id={"cb3" + index}
                      type="checkbox"
                    />

                    <label
                      className="tgl-btn"
                      data-tg-off="INCORRECT"
                      data-tg-on="CORRECT"
                      htmlFor={"cb3" + index}
                    /> */}

                  </td>
                );
              return <td key={index2}>{obj[attribute]}</td>;
            })}
            <td>
              <Button
                style={{ margin:10 }}
                bsSize="small"
                bsStyle="default"
                onClick={() => this.setState({ editModal: true, editObj: obj })}
              >
                Edit
              </Button>

              <Confirm
                show={this.state.deleteModal}
                onConfirm={() => this.handleConfirm(obj)}
                body="Are you sure you want to delete this answer?"
                confirmText="Confirm Delete"
                title="Delete Answer"
              >
                <Button
                  style={{ marginRight: "10px" }}
                  bsSize="small"
                  bsStyle="danger"
                  >
                  DELETE
                </Button>
              </Confirm>
            </td>
          </tr>
        ))
      );

    return (
      <div className="content">
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>#</th>
              {this.props.attributes.map((attribute, index) => (
                <th key={index}>{attribute}</th>
              ))}
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>{content}</tbody>
        </Table>

        <Modal
          show={this.state.editModal}
          onHide={() => this.setState({ editModal: false })}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Answer</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <form>
              <FormGroup controlId="formBasicText">
                <Row>
                  <Col xs={6} md={4}>
                    <ControlLabel>Answer's Text</ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.editObj.text}
                      placeholder="Enter the text of the answer"
                      onChange={e => this.handleEditChange(e, "text")}
                    />
                  </Col>

                  <Col xs={6} md={4}>
                    <ControlLabel>Order</ControlLabel>
                    <FormControl
                      type="number"
                      value={this.state.editObj.order}
                      placeholder="Enter the Order of the answer"
                      onChange={e => this.handleEditChange(e, "order")}
                    />
                  </Col>
                  <Col xs={6} md={4}>
                    <ControlLabel>Weight</ControlLabel>
                    <FormControl
                      type="number"
                      value={this.state.editObj.weight}
                      placeholder="Enter the weight of the answer"
                      onChange={e => this.handleEditChange(e, "weight")}
                    />
                  </Col>
                </Row>
              </FormGroup>
            </form>
          </Modal.Body>

          <Modal.Footer>

            <Button bsStyle="primary" onClick={this.handleUpdate}>
              {" "}
              Update
            </Button>

          </Modal.Footer>

        </Modal>
      </div>
    );
  }
}

export default AnswerTable;



// WEBPACK FOOTER //
// ./src/components/Table/AnswerTable.jsx